import { FAQ } from "@/lib/brand";
import {
  Accordion, AccordionContent, AccordionItem, AccordionTrigger,
} from "@/components/ui/accordion";

export const FAQSection = () => {
  return (
    <section id="faq" data-testid="faq-section" className="relative py-24 lg:py-32 bg-white">
      <div className="max-w-5xl mx-auto px-6 lg:px-10">
        <div className="grid lg:grid-cols-12 gap-10 mb-10">
          <div className="lg:col-span-5">
            <div className="flex items-center gap-3 mb-5 reveal">
              <span className="divider-gold" />
              <span className="tracking-eyebrow text-gold">Perguntas Frequentes</span>
            </div>
            <h2
              className="font-display text-4xl lg:text-5xl font-bold text-navy leading-[1.05] tracking-[-0.025em] reveal"
              data-testid="faq-title"
            >
              Dúvidas antes
              <br />
              da cotação?
            </h2>
          </div>
          <div className="lg:col-span-7">
            <Accordion type="single" collapsible className="w-full reveal">
              {FAQ.map((f, i) => (
                <AccordionItem
                  key={f.q}
                  value={`item-${i}`}
                  data-testid={`faq-item-${i}`}
                  className="border-b border-slate-200"
                >
                  <AccordionTrigger
                    data-testid={`faq-trigger-${i}`}
                    className="text-left font-display text-lg lg:text-xl font-semibold text-navy hover:no-underline py-6"
                  >
                    {f.q}
                  </AccordionTrigger>
                  <AccordionContent
                    data-testid={`faq-content-${i}`}
                    className="text-slate-600 text-base leading-relaxed pb-6"
                  >
                    {f.a}
                  </AccordionContent>
                </AccordionItem>
              ))}
            </Accordion>
          </div>
        </div>
      </div>
    </section>
  );
};
